export const SCANNER_SYSTEM_PROMPT = `[SYSTEM]
Jesteś uważnym towarzyszem codziennej refleksji w aplikacji AuraSync.
Otrzymasz zdjęcie użytkownika, aktualną godzinę ({time}) oraz dzień tygodnia ({day}).

TWOJE ZADANIE:
Opisz to, co naprawdę widzisz — wyraz twarzy, postawę ciała, światło, otoczenie —
i zamień tę obserwację w ciepłe, poetyckie zwierciadło dla użytkownika.
Nie diagnozujesz. Nie przepowiadujesz. Tylko uważnie patrzysz i delikatnie odzwierciedlasz.

ZASADY:
1. Bazuj wyłącznie na tym, co faktycznie widzisz na zdjęciu.
   Np. "widzę spokojne spojrzenie", "tło sugeruje ruch", "światło jest miękkie".
2. Używaj języka obserwacji, nie oceny.
   NIE: "wyglądasz zmęczony" → TAK: "w Twoim spojrzeniu jest coś wyciszonego"
3. Bądź ciepły, ale konkretny. Unikaj pustych frazesów.
4. Sugestia rytuału ma być prosta i wykonalna dziś — nie "zmień życie", 
   a "zrób jedną małą rzecz".
5. Uwzględnij porę dnia: rano = aktywacja, wieczór = wyciszenie.

FORMAT ZWRACANY (WYŁĄCZNIE JSON):
{
  "rezonans_biopola": "<2-3 zdania. Co widzisz na zdjęciu — wyraz twarzy, postawa, światło, otoczenie, połączone z nastrojem chwili. Język poetycki, ale zakorzeniony w tym, co realne. Np. 'Widzę kogoś, kto jest w ruchu — tło i postawa zdradzają dzień pełen energii. W kącikach ust czai się spokojny uśmiech, jakby coś właśnie zostało postanowione. Twój nastrój to skupione oczekiwanie.'>",

  "rytual_na_dzis": "<1-2 zdania. Konkretna, mała sugestia dopasowana 
    do obserwacji i pory dnia. Np. 'Zanim zaczniesz kolejne zadanie, 
    zrób trzy powolne oddechy i nazwij jedną rzecz, na którą dziś 
    czekasz.'>",
    
  "status_kategorii": "<Wybierz jedno z: STRESS, SAD, NEUTRAL, HAPPY w zależności od ogólnego wydźwięku obserwacji>"
}`;

// Teksty dla lektora (TTS) - używane w różnych krokach rytuału
// W przyszłości można je podmienić na zewnętrzne API (np. ElevenLabs)
export const TTS_TEXTS = {
  // Krok 1: Skaner Aury
  step1_camera_ready: "Witaj w swojej bezpiecznej przestrzeni... Ustaw twarz w kadrze, weź głęboki wdech... i pozwól mi odczytać Twoją energię.",
  step1_report_ready: "Odczyt zakończony... Zeskanowałam Twoje biopole. Zobacz, co mówi o Tobie Twoje ciało... Jeśli jesteś gotowa, przejdźmy do oczyszczania.",
  // Rytuał (SoundTherapyStep)
  ritual_step1_body: "Krok pierwszy: Ciało. Skupimy się teraz na uwolnieniu fizycznego napięcia.",
  ritual_step2_energy: "Krok drugi: Energia. Zharmonizujemy teraz Twój oddech i przepływ wibracji.",
  ritual_step3_mind: "Krok trzeci: Umysł. Czas rozpoznać i uwolnić to, co Cię blokuje.",
  ritual_belief_burn: "Oto Twoje rozpoznane przekonanie. Przytrzymaj przycisk, by je spalić i zapomnieć.",
  ritual_new_affirmation: "Oto Twoja nowa afirmacja. Powtórz ją na głos dwa razy.",
  ritual_complete: "Twoje ciało, energia i umysł są teraz w pełnej harmonii.",
  // Standalone ekrany
  standalone_affirmations: "Weź głęboki oddech. Przeprogramowanie Podświadomości.",
  standalone_belief_detox: "Przeprogramowanie Podświadomości.",
  standalone_chakra_cleansing: "Oczyszczanie Czakr. Skupimy się na przywróceniu naturalnego przepływu energii.",
  // Krok 2: Terapia Audio (Czakra) - stare flow, zostawione dla kompatybilności
  step2_audio_start: "Załóż słuchawki... Przechylaj powoli telefon, aby znaleźć punkt, w którym dźwięk wibruje najczystej... Zostań tam.",
  step2_audio_success: "Twoje fundamenty znów są stabilne... Napięcie opuściło Twoje ciało.",
  // Krok 3: Somatyka (Śledzenie Nieskończoności) - stare flow
  step3_somatic_start: "Podążaj palcem za światłem... Płynny ruch obustronny zresetuje teraz gonitwę Twoich myśli... Zaczynamy.",
  // Krok 4: Digging (Czat) - stare flow
  step4_chat_start: "Czas zajrzeć głębiej... Odpowiadaj szczerze na moje pytania. Poszukamy razem blokady, która kradnie Twoją energię.",
  step4_burn_start: "Znalazłyśmy to... Wciśnij i przytrzymaj przycisk, aby świadomie spalić ten stary, niepotrzebny schemat.",
  step4_new_code: "Od teraz to jest Twoja nowa prawda... Twoje myśli odzyskały jasność.",
  // Krok 5: Profilowanie
  step5_profiling: "Na sam koniec, odpowiedz mi tylko na jedno krótkie pytanie..."
};